import { render, staticRenderFns } from "./BusinessUnitPage.vue?vue&type=template&id=34dcbfab&scoped=true&"
import script from "./BusinessUnitPage.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dcbfab",
  null
  
)

export default component.exports